import { useMemo } from 'react';
import { useSelector } from 'react-redux';
import { useFulfillmentPlannerContext } from '../context';

import { useUserHasShippingRole } from '../../hooks/use-user-role';
import Global from '../../store/global-selectors';

export const useFulfillmentPlannerCreateLabel = () => {
  const { isCreatingLabel, didLabelCreationSucceed } = useFulfillmentPlannerContext();

  const userHasShippingRole = useUserHasShippingRole();
  const hasExternalProviders = useSelector(Global.selectSellerActiveFulfillmentProviders).length > 0;
  const hasShipFrom = useSelector(Global.selectSellerShipFroms).length > 0 || hasExternalProviders;

  return useMemo(() => {
    const isCreateLabelDisabled = Boolean(isCreatingLabel || didLabelCreationSucceed || !userHasShippingRole || !hasShipFrom);

    return { isCreateLabelDisabled };
  }, [didLabelCreationSucceed, hasShipFrom, isCreatingLabel, userHasShippingRole]);
};
